import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {TelemedicineEnum} from 'presentation/modules/booking/shared/constants/telemedicineEnum';
import {Unit} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';

export const hasOnlyTelemedicineUnit = (unitsList: Unit<FlowEnum.HEALTH>): boolean => {
	const unitsByLocality = unitsList?.units?.unitsByLocality ?? [];
	const unitsByDistance = unitsList?.units?.unitsByDistance ?? [];

	if (unitsByDistance.length !== 0) {
		return false;
	}

	if (unitsByLocality.length !== 1) {
		return false;
	}

	const [unit] = unitsByLocality;

	return unit.telemedicine === TelemedicineEnum.IS_TELEMEDICINE;
};
